<script lang="ts">
	import { beforeUpdate } from 'svelte';
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import {
		setupGen1TimerLogic,
		createGen1StatusLabels,
		createGen1CombinedLabelList,
		getGen1DeviceStatuses,
	} from '../../gen1-main-helpers';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import TimerRemaining from 'src/components/TimerRemaining/TimerRemaining.svelte';
	import type { Device } from 'src/types/Device.ts';
	import ControlSwitch from 'src/components/Controls/Single/ControlSwitch.svelte';
	import { devices_config } from 'src/configs/devices';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';

	/**
	 * Main control tab for SHSW-1 (Gen1 relay).
	 *
	 * This component is the main control tab (Main tab) for the SHSW-1 device (Shelly Switch Gen1).
	 * It displays the current state of the device, its main parameters, statuses, and allows switching the device on and off.
	 * If the device supports a timer, the remaining time is visualized through a dedicated component.
	 *
	 * @param {Device} device - The device for which the information is displayed.
	 */
	export let device: Device;

	$: deviceConfig = devices_config?.[device?.type];
	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: labelList = createGen1StatusLabels(_statuses, device);
	$: combinedLabelList = createGen1CombinedLabelList(timerLabels, labelList);

	let timerLabels: Record<string, any> = {};
	let gen1Timer = false;

	beforeUpdate(() => {
		if (
			device &&
			status !== undefined &&
			settings !== undefined &&
			deviceConfig !== undefined &&
			status?.online
		) {
			gen1Timer = setupGen1TimerLogic(device, status, false);
		}
	});
</script>

<DeviceViewStateWrapper {device}>
	<div
		slot="staticTop"
		class="label-list-wrapper mb-s d-flex flex-direction-column justify-content-center"
	>
		{#if device && status !== undefined && settings !== undefined && deviceConfig !== undefined && status?.online}
			{#if gen1Timer && status?.[`${device.category}s`]?.[device.channel]?.timer_started}
				{#key status[`${device.category}s`][device.channel].timer_started}
					<TimerRemaining timerKey="gen1_main" {device} {status} {settings} bind:timerLabels />
				{/key}
			{/if}
			<DeviceLabelList labelList={combinedLabelList} />
		{/if}
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>

	<div class="flex-full-height align-items-center justify-content-center" slot="content">
		<ControlSwitch {device} {status} {settings} isWide />
	</div>
</DeviceViewStateWrapper>
